module.exports = __webpack_public_path__ + "img/组 3.4fbc10b1.webp";